import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import ListItemIcon from '@mui/material/ListItemIcon';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { styled } from '@mui/material/styles';
import globals from '../globals.js';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PopUpMenu from './popUpMenu.jsx';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import RedButton from '../components/redButton.jsx';
import BlueButton from '../components/blueButton.jsx';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function AccountMenuMobile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const MenuButton = styled(Button)(() => ({
    color: globals.colors.lightRed,
    '&:hover': {
      backgroundColor: 'transparent',
      color: globals.colors.darkRed,
    },
    '&.Mui-selected': {
      color: globals.colors.darkRed,
    },
  }))

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl2(null);
    setAnchorEl(null);
  };

  // const handleClick2 = (event) => {
  //   setAnchorEl2(event.currentTarget);
  // };

  // const handleClose2 = () => {
  //   setAnchorEl2(null);
  // };

  const ITEM_HEIGHT = 48

  return (
    <React.Fragment>
      <Grid container justifyContent={'space-around'}>
        <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
          <a href='/'><img style={{ display: 'flex', flexShrink: 0, width: 180, height: 80, alignSelf: 'start' }} src='/eacademiabg-logo.webp' /></a>
        </Grid>
        <Grid display="flex" justifyContent="flex-end" alignItems="center" size="grow">
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              paper: {
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '13ch',
                },
              },
            }}
          >

            {/* ------------------------------------------------------------------------------------------- */}
            {/* Начало */}
            <MenuButton
              variant="text"
              href='/'
              size="small"
              sx={{ ml: 2 }}
            // aria-controls={open ? 'account-menu' : undefined}
            // aria-haspopup="true"
            // aria-expanded={open ? 'true' : undefined}
            >
              <Typography fontWeight={'bold'} fontSize={13}>
                Начало
              </Typography>
            </MenuButton>


            {/* ----------------------------------------------------------------------------------- */}
            {/* Курсове */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Курсове</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/courses'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      <Typography fontWeight={'bold'} fontSize={13}>Всички</Typography>
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/coming-soon'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Оферти
                    </MenuButton></>
                }
              ]}
            />

            {/* ----------------------------------------------------------------------------------- */}
            {/* Учители */}
            {/* <MenuButton
              variant="text"
              href='/instructors'
              size="small"
              sx={{ ml: 2 }}
            >
              <Typography fontWeight={'bold'} fontSize={13}>
                Учители
              </Typography>
            </MenuButton> */}

            {/* ----------------------------------------------------------------------------------- */}

            {/* Блог */}
            {/* <MenuButton
              variant="text"
              href='/coming-soon'
              size="small"
              sx={{ ml: 2 }}
            >
              <Typography fontWeight={'bold'} fontSize={13}>
                Блог
              </Typography>
            </MenuButton> */}

            {/* Учители */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Учители</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/instructors'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Нашите учители
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/new-instructor'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Стани учител
                    </MenuButton></>
                },
              ]}
            />

            {/* ----------------------------------------------------------------------------------- */}

            {/* Още - Блогове, Безплатни материали, Активности*/}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span style={{ marginRight: '-6px' }}>Още</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/competitions'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Конкурси
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/webinars'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Уебинари
                    </MenuButton></>
                },
              //   {
              //     link: "/redirect",
              //     text: <>
              //       <MenuButton
              //         variant='text'
              //         size='small'
              //         sx={{ ml: 2 }}>
              //         Блогове
              //       </MenuButton></>
              //   },
              //   {
              //     link: "/redirect",
              //     text: <>
              //       <MenuButton
              //         variant='text'
              //         size='small'
              //         sx={{ ml: 2 }}>
              //         Безплатни материали
              //       </MenuButton></>
              //   },
              //   {
              //     link: "/redirect",
              //     text: <>
              //       <MenuButton
              //         variant='text'
              //         size='small'
              //         sx={{ ml: 2 }}>
              //         Активности
              //       </MenuButton></>
              //   },
              ]}
            /> 

            {/* ----------------------------------------------------------------------------------- */}

            {/* За нас */}
            <PopUpMenu mainEl={
              <MenuButton
                variant="text"
                href=''
                size="small"
                sx={{ ml: 2 }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <Typography fontWeight={'bold'} fontSize={13}>
                  <span>За нас</span>
                </Typography>
              </MenuButton>}
              children={[
                {
                  onClick: () => navigate('/about-us'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Кой сме ние?
                    </MenuButton></>
                },
                {
                  onClick: () => navigate('/contact-us'),
                  text: <>
                    <MenuButton
                      variant='text'
                      size='small'
                      sx={{ ml: 2 }}>
                      Контакти
                    </MenuButton></>
                }
              ]}
            />

            {/* ----------------------------------------------------------------------------------- */}

            {/* Avatar */}
            <PopUpMenu mainEl={
              <Tooltip title="Настройки на акаунта">
                {user ?
                  <IconButton
                    size="small"
                    sx={{ ml: 2 }}
                  >
                    <Avatar sx={{ width: 32, height: 32 }} src={user ? user.image_url : null}>
                      {user.image_url ? null : user.first_name.charAt(0)}
                    </Avatar>
                  </IconButton>
                  :
                  <>
                    <RedButton text='Регистрация' href="/register" size='small' sx={{ ml: 2 }} />
                    <BlueButton text='Вход' href="/login" size='small' sx={{ ml: 2 }} pX={2} />
                  </>
                }
              </Tooltip>}
              children={[
                {
                  onClick: () => navigate('/profile'),
                  text: <>
                    <ListItemIcon>
                      <PersonOutlineIcon fontSize="small" />
                    </ListItemIcon>Към Моя Профил</>
                },
                {
                  onClick: () => navigate('/saved'),
                  text: <>
                    <ListItemIcon>
                      <BookmarkIcon fontSize="small" />
                    </ListItemIcon>Запазени курсове</>
                },
                {
                  onClick: () => navigate('/cart'),
                  text: <>
                    <ListItemIcon>
                      <Settings fontSize="small" />
                    </ListItemIcon>Количка</>
                },
                {
                  // link: "/redirect",
                  onClick: () => logout(),
                  text: <>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>Изход</>
                }
              ]}
            />
          </Menu>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}